module.exports = __webpack_public_path__ + "img/KinokoTable01.09ffde37.jpg";